import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Permissions } from '@app/entities/enums/permissions/permissions.enum';
import { User } from '@app/entities/models/user/user.model';
import { StorageService, STORAGE_CONSTANTS } from '@app/services/storage';
import { InternalRoute } from '@app/shared/helpers/route.helper';
import { ENV } from '@environments/environment';
import { Logger } from '@services/logger/logger.service';
import { NavigationEvent, NavigationEvents, NavigationService } from '@services/navigation/navigation.service';

import { AppManagerService, AppStatus } from '../app/app.manager.service';
import { NavigationHelperService } from '../navigation/navigation.helper.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuardService {
  private readonly logger = new Logger('PermissionsGuardService');
  private route!: ActivatedRouteSnapshot;

  constructor(
    private navigationService: NavigationService,
    private storage: StorageService,
    private navigationHelperService: NavigationHelperService,
    private appManager: AppManagerService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    this.route = route;

    const canAccess = await this.canAccessPage();
    const eventType: NavigationEvents = NavigationEvents.SetRoot;
    const internalRoute: InternalRoute = { path: this.route.data.redirectTo };

    if (!canAccess) {
      this.logger.error('User has not permissions to access ' + this.route.url);

      if (this.appManager.status === AppStatus.INIT) {
        this.navigationHelperService.doRedirect(eventType, internalRoute);
      } else {
        const navEvent = new NavigationEvent(eventType, internalRoute);
        this.navigationService.navigate(navEvent);
      }
    }

    return canAccess;
  }

  private async canAccessPage(): Promise<boolean> {
    if (ENV.fullAccessPtrab) {
      return true;
    }

    const user: User = await this.storage.get(STORAGE_CONSTANTS.USER);
    const userPermissions = (user && user.permissions) || [];
    const pagePermissions: Permissions[] = this.route.data.pagePermissions || [];

    return pagePermissions.some((permission) => userPermissions.includes(permission));
  }
}
